import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { useGame } from "@/context/GameContext";
import { Sound } from "@/lib/sound";
import SaveLoadModal from "@/components/SaveLoadModal";
import LandingHero from "@/components/landing/LandingHero";
import HowItWorks from "@/components/landing/HowItWorks";
import BusinessShowcase from "@/components/landing/BusinessShowcase";
import LearnGrid from "@/components/landing/LearnGrid";
import ParentsNote from "@/components/landing/ParentsNote";
import LandingFaq from "@/components/landing/LandingFaq";
import InsideTheGame from "@/components/landing/InsideTheGame";
import Testimonials from "@/components/landing/Testimonials";
import { Play } from "lucide-react";

const Landing = () => {
  const { state, markLandingDone } = useGame();
  const navigate = useNavigate();
  const [saveOpen, setSaveOpen] = useState(false);

  const play = () => {
    Sound.primeOnFirstInteraction();
    Sound.fanfare();
    markLandingDone();
    navigate("/");
  };

  return (
    <div className="min-h-screen dotted-bg" data-testid="landing-page">
      <header className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-6 flex items-center justify-between">
        <div className="flex items-center gap-2">
          <span className="text-3xl">💼</span>
          <span className="font-display text-2xl font-bold text-amber-500 tracking-tight" data-testid="landing-brand">Kids Biz Boss</span>
        </div>
        {state.playerName && (
          <Button onClick={() => navigate("/")} data-testid="landing-continue-btn" className="bg-amber-400 hover:bg-amber-500 text-slate-900 font-heading font-black rounded-2xl btn-3d border-2 border-amber-500">
            Continue my game →
          </Button>
        )}
      </header>

      <LandingHero onPlay={play} onLoad={() => { Sound.click(); setSaveOpen(true); }} />
      <HowItWorks />
      <BusinessShowcase />
      <InsideTheGame />
      <LearnGrid />
      <Testimonials />
      <ParentsNote />
      <LandingFaq />

      <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pb-16 text-center" data-testid="landing-footer-cta">
        <h2 className="font-display text-2xl sm:text-3xl lg:text-4xl font-bold text-slate-900 tracking-tight">Ready to open shop, boss?</h2>
        <Button onClick={play} data-testid="landing-play-free-bottom-btn" className="mt-6 w-full sm:w-auto whitespace-normal bg-emerald-500 hover:bg-emerald-600 text-white font-heading font-black text-lg px-6 sm:px-10 py-7 rounded-2xl btn-3d border-2 border-emerald-600">
          <Play className="w-5 h-5 mr-2 fill-white shrink-0" /> Play Free — start Dog Walking
        </Button>
      </section>

      <SaveLoadModal open={saveOpen} onClose={() => setSaveOpen(false)} />
    </div>
  );
};

export default Landing;
